import { isVNode as A } from "vue";
import { isArray as r } from "./index575.js";
var _ = /* @__PURE__ */ ((E) => (E[E.TEXT = 1] = "TEXT", E[E.CLASS = 2] = "CLASS", E[E.STYLE = 4] = "STYLE", E[E.PROPS = 8] = "PROPS", E[E.FULL_PROPS = 16] = "FULL_PROPS", E[E.HYDRATE_EVENTS = 32] = "HYDRATE_EVENTS", E[E.STABLE_FRAGMENT = 64] = "STABLE_FRAGMENT", E[E.KEYED_FRAGMENT = 128] = "KEYED_FRAGMENT", E[E.UNKEYED_FRAGMENT = 256] = "UNKEYED_FRAGMENT", E[E.NEED_PATCH = 512] = "NEED_PATCH", E[E.DYNAMIC_SLOTS = 1024] = "DYNAMIC_SLOTS", E[E.HOISTED = -1] = "HOISTED", E[E.BAIL = -2] = "BAIL", E))(_ || {});
const S = (E) => {
  const N = r(E) ? E : [E], e = [];
  return N.forEach((T) => {
    var o;
    r(T) ? e.push(...S(T)) : A(T) && ((o = T.component) != null && o.subTree) ? e.push(T, ...S(T.component.subTree)) : A(T) && r(T.children) ? e.push(...S(T.children)) : A(T) && T.shapeFlag === 2 ? e.push(...S(T.type())) : e.push(T);
  }), e;
};
export {
  _ as PatchFlags,
  S as flattedChildren
};
